export enum TravellerType {
    ADT = 'ADT',
    CHD = 'CHD',
    INF = 'INF'
}